import { assign } from '../common/utils';

const initialState = {
    navCurIndex: 0
}

const nav = (state = initialState, action) => {
    switch (action.type) {
        case 'nav_change':
            return assign(state, {
                navCurIndex: action.navCurIndex
            });
        
        default:
            return state;
    }
};

export default nav;